/**
 * Date utility functions for chat messages
 * Formats dates in Vietnamese style with relative dates
 */

/**
 * Format date to Vietnamese display
 * - Today: "Hôm nay"
 * - Yesterday: "Hôm qua"
 * - This week: "Thứ Hai, 18/12"
 * - Older: "18/12/2024"
 */
export const formatDateHeader = (date: Date): string => {
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);

  // Reset time to compare dates only
  const dateOnly = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  const todayOnly = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  const yesterdayOnly = new Date(yesterday.getFullYear(), yesterday.getMonth(), yesterday.getDate());

  if (dateOnly.getTime() === todayOnly.getTime()) {
    return "Hôm nay";
  }

  if (dateOnly.getTime() === yesterdayOnly.getTime()) {
    return "Hôm qua";
  }

  // Check if within this week
  const daysDiff = Math.floor((todayOnly.getTime() - dateOnly.getTime()) / (1000 * 60 * 60 * 24));
  if (daysDiff < 7 && daysDiff > 0) {
    const weekdays = ["Chủ Nhật", "Thứ Hai", "Thứ Ba", "Thứ Tư", "Thứ Năm", "Thứ Sáu", "Thứ Bảy"];
    const dayName = weekdays[date.getDay()];
    const dateStr = `${date.getDate()}/${date.getMonth() + 1}`;
    return `${dayName}, ${dateStr}`;
  }

  // Older dates
  const year = date.getFullYear() !== today.getFullYear() ? `/${date.getFullYear()}` : "";
  return `${date.getDate()}/${date.getMonth() + 1}${year}`;
};

/**
 * Check if two dates are on the same day
 */
export const isSameDay = (date1: Date, date2: Date): boolean => {
  return (
    date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate()
  );
};
